var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _line, _line2, _line3, _line4, _line5, _line6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonnelEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 449,
    height: 146,
    viewBox: "0 0 449 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.537 0H190.736V9.87274H209.901V127.184H236.616V22.6492H288.883V60.3979H295.852V46.4599H309.79V60.3979H324.309V46.4599L361.477 58.8402V96.4044H381.222V127.184H402.71V134.153H381.222H361.477H352.766H336.505H324.309H309.79H295.852H288.883H274.945H236.616H209.901H190.736H165.183H160.537H151.826H123.37H121.047H111.174H105.366H77.4903H67.0369H46.1299V127.184H67.0369V112.085H77.4903V91.7584H105.366V112.085H111.174V73.7552V58.6557C111.174 51.9202 116.634 46.4599 123.37 46.4599C130.105 46.4599 135.565 51.9202 135.565 58.6557V73.7552H151.826V9.87274H160.537V0Z",
    fill: "#F4F7F8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 185.83,
    y: 88.3818,
    width: 78.5151,
    height: 35.6895,
    fill: "white",
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 198.902,
    y: 100.272,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 218.548,
    y: 100.272,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 238.193,
    y: 100.272,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 185.831,
    y: 52.6919,
    width: 78.5151,
    height: 35.6895,
    fill: "white",
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 198.902,
    y: 64.584,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 218.548,
    y: 64.5835,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 238.193,
    y: 64.5835,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 185.832,
    y: 17,
    width: 78.5151,
    height: 35.6895,
    fill: "white",
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 198.903,
    y: 28.8916,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 218.549,
    y: 28.8916,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 238.195,
    y: 28.8916,
    width: 13.0858,
    height: 11.8965,
    fill: "#6F7985"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 166.13,
    y: 124.472,
    width: 117.773,
    height: 17.8447,
    fill: "white",
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 180.373,
    y1: 143.496,
    x2: 180.373,
    y2: 125.651,
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 197.466,
    y1: 143.496,
    x2: 197.466,
    y2: 125.651,
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 214.559,
    y1: 143.496,
    x2: 214.559,
    y2: 125.651,
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 231.653,
    y1: 143.496,
    x2: 231.653,
    y2: 125.651,
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 248.745,
    y1: 143.496,
    x2: 248.745,
    y2: 125.651,
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 265.838,
    y1: 143.496,
    x2: 265.838,
    y2: 125.651,
    stroke: "#6F7985",
    strokeWidth: 5.69773
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnelEmptyState);
export default __webpack_public_path__ + "static/media/personnelEmptyState.30c0e783e03b471a1b1f011ad700c4c2.svg";
export { ForwardRef as ReactComponent };